import { Container, Title, Text, Box, ThemeIcon, Stack } from "@mantine/core";
import { IconHelp } from "@tabler/icons-react";

export default function SupportHeroSection() {
  return (
    <Box
      style={{
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(to top, rgba(235, 248, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%)",
      }}
      pt={160}
      pb={160}
    >
      <Container size="lg" style={{ position: "relative", zIndex: 1 }}>
        <Stack align="center" gap="xl">
          {/* Icon */}
          <ThemeIcon size={100} radius="50%" color="primary" variant="light">
            <IconHelp size={50} />
          </ThemeIcon>

          {/* Headline */}
          <Title order={1} ta="center" fw={400}>
            Help & Support
          </Title>

          {/* Subheadline */}
          <Text ta="center" c="slate.6" size="xl" maw={700}>
            Find answers to common questions or reach out to our support team
          </Text>
        </Stack>
      </Container>
    </Box>
  );
}
